var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Grid, List, ListItem, ListItemText, makeStyles, Typography, } from "@material-ui/core";
import CreateNew from "../../../common/createNew";
import SearchInput from "tsf_search/dist/components/searchInput";
import React from "react";
import styled from "styled-components";
import Moment from "react-moment";
import EmptyList from "../emptyList";
var useStyles = makeStyles(function (theme) { return ({
    SearchWrapper: {
        padding: "10px 0",
        backgroundColor: theme.palette.secondary.main,
        textAlign: "center",
    },
    activeClass: {
        boxShadow: "4px 4px 10px rgb(0 0 0 / 25%)",
        borderRight: "4px solid #000",
        borderRightColor: theme.palette.secondary.main,
    },
    dataTypography: {
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "10px",
        lineHeight: "12px",
        color: "#404268",
    },
}); });
var MinimizedList = function (_a) {
    var className = _a.className, data = _a.data, showCreateNewButton = _a.showCreateNewButton, activeTaskId = _a.activeTaskId, showSearchFeild = _a.showSearchFeild, rowClicked = _a.rowClicked, handleCreateNew = _a.handleCreateNew, handleSearch = _a.handleSearch;
    var classes = useStyles();
    return (React.createElement("div", { className: className },
        showCreateNewButton && (React.createElement(CreateNewWrapper, null,
            React.createElement(CreateNew, { height: 45, width: 175, handleCreateNew: handleCreateNew }))),
        showSearchFeild && (React.createElement("div", { className: classes.SearchWrapper },
            React.createElement(SearchInputBox, { handleSearch: handleSearch }))),
        (!data || (data && data.length === 0)) && React.createElement(EmptyList, null),
        data && data.length > 0 && (React.createElement(List, { dense: true }, data &&
            data.length > 0 &&
            data.map(function (item) { return (React.createElement(DataListItem, { key: item.id, onClick: function () {
                    return rowClicked ? rowClicked(item) : console.log(item);
                }, className: activeTaskId == item.id ? classes.activeClass : "" },
                React.createElement(DataListItemSection, null,
                    React.createElement(DataListItemText, { primary: item.name }),
                    React.createElement(Grid, { container: true, spacing: 1 },
                        React.createElement(Grid, { item: true, lg: 5, md: 5, xs: 12 },
                            React.createElement(Typography, { gutterBottom: true, className: classes.dataTypography },
                                "Created by : ",
                                item.createdByName)),
                        React.createElement(Grid, { item: true, lg: 7, md: 7, xs: 12 },
                            React.createElement(Typography, { className: classes.dataTypography },
                                "Created on :",
                                " ",
                                React.createElement(Moment, { format: "YYYY/MM/DD" }, item.createdOn ? item.createdOn : null))))))); })))));
};
export default MinimizedList;
var DataListItem = styled(ListItem)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 12px 16px 12px 20px;\n  border-bottom: 1px solid #e4e4f0;\n  cursor: pointer;\n"], ["\n  padding: 12px 16px 12px 20px;\n  border-bottom: 1px solid #e4e4f0;\n  cursor: pointer;\n"])));
var DataListItemSection = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var DataListItemText = styled(ListItemText)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 16px;\n  color: #2d2d2d;\n"], ["\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 16px;\n  color: #2d2d2d;\n"])));
// const DataTypography = styled(Typography)`
//   font-style: normal;
//   font-weight: normal;
//   font-size: 10px;
//   line-height: 12px;
//   color: #404268;
// `;
var CreateNewWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: 10px 0px;\n  text-align: center;\n  border-radius: 12px;\n  background-color: white;\n"], ["\n  padding: 10px 0px;\n  text-align: center;\n  border-radius: 12px;\n  background-color: white;\n"])));
var SearchWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  padding: 10px 0;\n  background-color: #404268;\n  text-align: center;\n"], ["\n  padding: 10px 0;\n  background-color: #404268;\n  text-align: center;\n"])));
var SearchInputBox = styled(SearchInput)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  width: 214px;\n  height: 42px;\n"], ["\n  width: 214px;\n  height: 42px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=index.js.map